module.exports = __webpack_public_path__ + "static/banner_bg_2-e34382c32e1e676dfaf65f07a1d06bc6.png";